import { loadSessionString, hasStoredSessionString } from './sessions';
import { StringSession } from '../lib/gramjs/sessions';
import type { ApiSessionData } from '../api/types';

/**
 * Load session string from localStorage and convert to session data
 * This should only be called from the main thread, not from Web Workers
 */
export function loadSessionStringFromStorage(): ApiSessionData | null {
  // Check if we're in a Web Worker context
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    console.warn('⚠️ Cannot access localStorage in Web Worker context');
    return null;
  }

  try {
    if (!hasStoredSessionString()) {
      console.log('📭 No session string found in localStorage');
      return null;
    }

    console.log('🔍 Found session string in localStorage, attempting to use it...');
    const sessionString = loadSessionString();
    
    if (!sessionString) {
      console.warn('⚠️ Failed to load session string from localStorage');
      return null;
    }

    console.log('🔐 Session string length:', sessionString.length);
    
    // Use StringSession to parse the session string
    const stringSession = new StringSession(sessionString);
    stringSession.load();
    const sessionData = stringSession.getSessionData();
    
    if (sessionData && Object.keys(sessionData.keys).length > 0) {
      console.log('✅ Successfully converted session string to session data:', {
        mainDcId: sessionData.mainDcId,
        keysCount: Object.keys(sessionData.keys).length,
        isTest: sessionData.isTest,
      });
      return sessionData;
    } else {
      console.warn('⚠️ Failed to convert session string, no valid session data');
      return null;
    }
  } catch (error) {
    console.error('❌ Error loading session string:', error);
    return null;
  }
}

/**
 * Check if we should use session string from localStorage
 */
export function shouldUseSessionString(): boolean {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return false;
  }
  
  return hasStoredSessionString();
}
